export const ADD_SPARKED_PARKING_DATA = 'ADD_SPARKED_PARKING_DATA'

export function sparkedParkingDataReducer(state = {}, action) {
    switch (action.type){
        case ADD_SPARKED_PARKING_DATA:
            return action.payload
        default: return state
    }
}